import helpers from "../helpers/helpers";
export default {
  modelName: 'audit_template',
  versionModelName: 'audit_template_version',
  label: '稽核公版',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    // nameForIndex:{
    //   type:'custom',
    //   getValue(item){

    //   },
    //   getDescription(item){

    //   },
    // },
    sequence: {
      type: 'number',
      label: '排序',
      maxlength: 10,
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      }
    },
    status: {
      type: 'select',
      label: '',
      defaultValue: '0',
      items: [
        {
          text: '顯示',
          value: 1,
        },
        {
          text: '隱藏',
          value: 0,
        },
        {
          text: '修訂中',
          value: 2,
        },
      ],
    },
    last_version: {
      type: 'last_version',
      label: '',
      modelName: 'audit_template_version',
      showFields: ['name_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          // label: "多語言內容",
          fields: {
            name: {
              type: 'text',
              label: '稽核表名稱',
              rules: 'required',
              maxlength: 30,
            },
            remark: {
              type: 'text',
              label: '備註',
              maxlength: 1000,
            },
          },
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          textKey: 'name',
          readonly: true,
        },
        updated_at: {
          type: 'datetime',
          label: '更新時間',
          readonly: true,
        },
      },
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '稽核表名稱',
          rules: 'required',
          maxlength: 30,
        },
        remark: {
          type: 'text',
          label: '備註',
          maxlength: 1000,
        },
      },
    },
    name: {
      type: 'text',
      label: '稽核公版名稱',
      readonly: true,
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    system_classes: {
      label: '領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'areas',
      width: '150px',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: "array",
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      rules: 'required',
      textKey: 'name',
      width: '150px',
      modelName: 'system_subclass',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return true
        } else if(modelData.range_type === "exclusive") {
          return false
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return false
        } else if(modelData.range_type === "exclusive") {
          return true
        }
      },
      getRules: (modelData) =>{
        if (modelData.range_type === "exclusive") {
          return "required"
        } else {
          return null
        }
      }
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: 'custom',
    //   label: '上次修改時間',
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
  },
};
